import axiosMemed from './axiosMemed'

const setToken = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const crm = ('0000' + payload.codeCustomer).slice(-4) + '$' + payload.crm
    const url = `/doctor/${crm}`
    axiosMemed.get(url)
      .then((resultToken) => {
        resolve(commit('SET_TOKEN', resultToken.data.token))
      })
      .catch((err) => {
        console.error(err)
        reject(err)
      })
  })
}

const createMemed = ({ commit }, payload) => {
  const dataBody = {
    data: {
      'type': 'usuarios',
      'attributes': {
        'external_id': ('0000' + payload.codeCustomer).slice(-4) + '$' + payload.crm,
        'nome': payload.name,
        'sobrenome': payload.name,
        'data_nascimento': null || payload.birthDay,
        'cpf': null || payload.cpf,
        'email': payload.username,
        'uf': 'PR' || payload.state,
        'sexo': null || payload.gender,
        'crm': payload.crm
      },
      'relationships': {
        // Cidade do profissional (recomendado, não obrigatório)
        'cidade': {
          'data': {
            'type': 'cidades',
            'id': '2853'
          }
        },
        // Especialidade do profissional: Clínica médica, Oftalmologia, etc. (recomendado para otimizarmos nossa busca)
        'especialidade': {
          'data': {
            'type': 'especialidades',
            'id': '69'
          }
        }
      }
    }
  }
  const url = `/doctor/create`
  axiosMemed.post(url, dataBody)
    .then((resultToken) => {
      setToken(payload)
    })
    .catch((err) => {
      console.error(err)
    })
}

const createPatientMemed = ({ commit }, payload) => {
  console.log(payload)
  const dataBody = {
    name: payload.title,
    idExternal: payload.code,
    address: null,
    phone: payload.mobile,
    city: null,
    idCustomer: payload.idCustomer
  }
  return new Promise((resolve, reject) => {
    const url = `/patients`
    axiosMemed.post(url, dataBody)
      .then((resultToken) => {
        // resolve(commit('SET_TOKEN', resultToken.data.token))
      })
      .catch((err) => {
        console.error(err)
        reject(err)
      })
  })
}

const createPrescription = ({ commit }, payload) => {
  console.log(payload)
  // return new Promise((resolve, reject) => {
  //   const url = `/prescription`
  //   axiosMemed.post(url)
  //     .then((resultToken) => {
  //       resolve(commit('SET_TOKEN', resultToken.data.token))
  //     })
  //     .catch((err) => {
  //       console.error(err)
  //       reject(err)
  //     })
  // })
}

export default {
  setToken,
  createMemed,
  createPatientMemed,
  createPrescription
}



// WEBPACK FOOTER //
// ./src/store/modules/memed/actions.js